const reTrim = /^\s+|\s+$/g
export default reTrim
